import React from 'react'
import { Breadcrumbs as MuiBreadcrumbs } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'

import { Typography, TextLink } from '~/legacy/components'

export const Breadcrumbs = withStyles({
  separator: {
    marginTop: '2px',
  },
})(({ classes, pieces }) => {
  return (
    <MuiBreadcrumbs
      aria-label="breadcrumb"
      separator={
        <NavigateNextIcon className={classes.separator} fontSize="small" />
      }
    >
      {pieces.map((piece, index) => {
        // Make the last breadcrumb not a clickable link
        return index === pieces.length - 1 || !piece.path ? (
          <Typography color="textPrimary" key={piece.name} variant="h3">
            {piece.name || ''}
          </Typography>
        ) : (
          <TextLink
            color="inherit"
            key={piece.name}
            onClick={() => {
              // This is because we need avoid the client side routing
              // since we are going from the legacy frontend to the nextjs app
              const url = new URL(window.location.href)
              url.pathname = piece.path
              window.location.href = url.toString()
            }}
            variant="h3"
          >
            {piece.name || ''}
          </TextLink>
        )
      })}
    </MuiBreadcrumbs>
  )
})
